import api from '../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

/* CSS */

import '../../shared/components/form/inputDefault.css'

/* form */
import Input from "../../shared/components/form/input"

/* Hooks */
import useMyPermission from '../../hooks/useMyPermission'

import ListAviamentoRow from './ListRow/ListAviamentoRow'
import Modal from '../../shared/modal/Modal'
import NewAviamento from './NewAviamento'
import Button from '../../shared/components/Button/Button'


function Aviamento({ selectItem, handleOnSelectItem, selectedData }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const [aviamentos, setAviamentos] = useState([])
    const [modalNew, setModalNew] = useState(false)

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const { checkPermission } = useMyPermission()
    const myPermissionNew = checkPermission(myPermission, "aviamento_create")
    const myPermissionView = checkPermission(myPermission, "aviamento_view")
    const myPermissionEdit = checkPermission(myPermission, "aviamento_edit")
    const myPermissionDelete = checkPermission(myPermission, "aviamento_delete")

    /* get all function */
    const getAll = () => {
        api.get(`/aviamento/getall`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                setAviamentos(response.data.aviamentos)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    /* use effect */
    useEffect(() => {
        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    /* ----------------------- Search function ---------------------------------- */
    const filter = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return aviamentos.filter((item) => item.name.toLowerCase().includes(searchLowerCase))
    }, [aviamentos, search])

    function handleSearch(e) {
        setSearch(e.target.value)
    }

    if (!load) {
        return <div className="pg-loading">Carregando aviamentos...</div>
    }

    /* PAGE */
    return myPermissionView ? (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Aviamentos</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            {myPermissionNew && (
                                <Button variant="new" onClick={() => setModalNew(true)}>Cadastrar</Button>
                            )}
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar por nome..."
                                    value={search}
                                    handleOnChange={handleSearch}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'aviamento' : 'aviamentos'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListAviamentoRow
                        dataArray={filter}
                        handleOnSuccess={getAll}
                        handleOnSelectItem={handleOnSelectItem}
                        myPermissionEdit={myPermissionEdit}
                        myPermissionDelete={myPermissionDelete}
                        myPermissionView={myPermissionView}
                        selectItem={selectItem}
                        selectedData={selectedData}
                    />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum aviamento encontrado</p>
                        <p className="pg-empty-subtitle">
                            {aviamentos.length === 0
                                ? 'Cadastre o primeiro aviamento para começar.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNew}
                changeStatus={setModalNew}
                w={80}
                content={
                    <NewAviamento btCancelAction={() => setModalNew(false)} handleOnSuccess={() => { setModalNew(false); getAll() }} />
                }
            />

        </section>
    ) : (
        <div className="pg-empty">
            <p className="pg-empty-title">Sem permissão para visualizar aviamentos</p>
        </div>
    )
}

export default Aviamento
